// extracted by mini-css-extract-plugin
export default {"item":"CartItem_item__zwUP5","imgDiv":"CartItem_imgDiv__Ny3DI","infos":"CartItem_infos__PHSDP","price":"CartItem_price__OqdEp","btn":"CartItem_btn__8krFz"};